module.exports = __webpack_public_path__ + "static/media/Zinc-Screenshot-4.85c35182.png";